'use client'

import React from 'react'
import ReactMarkdown from 'react-markdown'

import { useQuery } from '@apollo/client'

import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Column, Loader, Row, Text } from 'Components/UI'
import { APOLLO_CLIENT_CONTEXT_ID } from 'Config/apolloClient'
import { DateTime } from 'luxon'

import { LANDING_CONTENT_PX, LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import { TermsPageDocument } from 'GraphQL/DatoCMS/TypedDocuments'

import { useResponsiveLayout } from 'Hooks'

function TermsPage() {
  const { isDesktop } = useResponsiveLayout()

  const { data, loading } = useQuery(TermsPageDocument, {
    context: { [APOLLO_CLIENT_CONTEXT_ID.Dato]: true },
  })

  const document = data?.termsPage?.document

  if (loading) return <Loader fullScreen size={32} />

  if (!document) return null

  return (
    <Column
      alignCenter
      fullWidth
      gap={8}
      maxWidth={LANDING_CONTENT_WIDTH_PX}
      px={LANDING_CONTENT_PX}
      py={5}
    >
      <Row>{document.title && <SubsectionTitle title={document?.title} />}</Row>

      <Column fullWidth gap={5}>
        {document.sections.map(section => (
          <Column gap={3} key={section.id}>
            <Text bold important screen20={isDesktop}>
              {section.heading}
            </Text>

            <div className="legal-content">
              <ReactMarkdown>{section.content}</ReactMarkdown>
            </div>
          </Column>
        ))}
      </Column>

      {document.dateUpdated && (
        <Row alignStart fullWidth>
          <Text body medium screen16={!isDesktop} screen20={isDesktop}>
            {`Policy Updated: ${DateTime.fromFormat(
              document.dateUpdated,
              'yyyy-MM-dd',
            ).toFormat('MM/yyyy')}`}
          </Text>
        </Row>
      )}
    </Column>
  )
}

export default TermsPage
